import React from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import Accordion from "components/Accordion/Accordion.jsx";
import CardUtilizador from "components/CardUtilizador";

import withStyles from "@material-ui/core/styles/withStyles";
import cursosStyle from "assets/jss/material-dashboard-pro-react/views/cursosStyle";
import MomentFromNow from "../../../components/MomentFromNow";
import general from "../../../general";
import Button from "../../../components/CustomButtons/Button";
import SweetAlert from "../../../components/SweetAlertWrapper";
import connection from "../../../connection";
import Tooltip from "@material-ui/core/Tooltip";
import AccessTime from "@material-ui/icons/AccessTime";
import StateCircle from "../../../components/StateCircle";
import {SlideDown} from "react-slidedown";

import EstadoParticipacaoCurso from "../../../components/EstadoParticipacaoCurso";
import EstadoParticipacaoModulo from "../../../components/EstadoParticipacaoModulo";
import CheckParticipacaoModulos from "../../../components/CheckParticipacaoModulos";

import {Hidden} from "@material-ui/core";
import PaginaFormacao from "../PaginaFormacao";
import {fases} from "./fases";
import ConfirmarRegisto from "../../../components/ConfirmarRegisto/ConfirmarRegisto";

class VisualizacaoCurso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curso: props.detalhes,
      modal: null,
      estado_participacao: props.detalhes.registo.estado ? JSON.parse(props.detalhes.registo.estado) : null
    };

    this.hideModal = this.hideModal.bind(this);

    this.reloadModulosParticipante = async () => {
      this.setState({
        modulos_participante: await connection.get("curso/modulos_participante", {curso_id: this.state.curso.id, curso_apenas: !this.state.curso.registo.aprovado}),
        modal: null
      });
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {curso: props.detalhes};
  }

  componentDidMount() {
    this.reloadModulosParticipante();
  }

  hideModal() {
    this.setState({
      modal: null
    });
  }

  render() {
    const {classes} = this.props;
    const {curso} = this.state;

    let preco = curso.preco_inscricao.toFixed(2).replace(".", ",") + "€";

    let texto_registo = (() => {
      let registos_fechados = curso.data_limite_registos && new Date(curso.data_limite_registos) <= new Date();
      let registos_finalizados = curso.data_registos_fechados && new Date(curso.data_registos_fechados) <= new Date();

      let texto = null;
      if (curso.registo.selecionado) {
        if (curso.registo.aprovado) {
          if (curso.registo.preco > 0)
            texto = "É agora participante deste curso";
          else
            texto = "Foi selecionado e é agora participante deste curso.";
        } else {
          texto = <span>Foi selecionado e deverá efetuar o pagamento <MomentFromNow
            time={curso.registo.limite_pagamento}/></span>;
        }

      } else if (curso.registo.registado) {
        if (registos_finalizados)
          texto = "Infelizmente não foi selecionado para participar neste curso. Em caso de dúvidas contacte o diretor.";
        else {
          if (registos_fechados)
            texto = "O registo está a ser revisto.";
          else
            texto = "O seu registo foi efetuado, aguarde pelo fecho dos registos.";
        }
      } else {
        if (curso.data_abertura_registos && new Date(curso.data_abertura_registos) > new Date())
          texto =
            <span>Os registos serão abertos a {general.Renderers.dateRenderer(curso.data_abertura_registos)}</span>;
        else {
          if (registos_fechados)
            texto = "Os registos estão fechados, não poderá candidatar-se a este curso. Em caso de dúvidas contacte o diretor.";
          else
            texto = <span>Poderá fazer o registo até <span style={{whiteSpace: "nowrap"}}>{general.Renderers.dateRenderer(curso.data_limite_registos)}</span></span>;
        }
      }
      return texto;
    })();

    return <div className={classes.cursosContainer}>
      <div className={classes.eventLabel}>
        <p>Curso</p>
        <h2>{curso.designacao}</h2>
      </div>
      {fases(curso)}
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12} sm={8}>
          {curso.registo.aprovado ? <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Participar em formações</h4>
              <p>Utilize a lista de módulos abaixo para se inscrever nas formações.</p>
            </CardHeader>
            <CardBody className={classes.courseDetails} style={{paddingLeft: 0, paddingRight: 0}}>
              {this.state.modulos_participante ?
                this.state.modulos_participante.areas.map((area) => {
                  let accordionContent = [];
                  let modulosObrigatorios = "";
                  let modulosObrigatoriosNum = area.modulos_obrigatorios.length;
                  if (modulosObrigatoriosNum > 0)
                    modulosObrigatorios = modulosObrigatoriosNum + (modulosObrigatoriosNum > 1 ? " módulos obrigatórios" : " módulo obrigatório");

                  return <React.Fragment>
                    <div className={classes.modulosAreaHeaderContainer}>
                      <h3 style={{margin: 0, fontSize: "18px"}}>{area.designacao}</h3>
                      <h5 style={{margin: 0, fontSize: 15}}>
                        {modulosObrigatorios}
                        <span className={classes.modulosAreaHeaderTypeLabel}>Área</span>
                      </h5>
                    </div>
                    <div className={classes.modulosParticipanteAccordionWrapper}>
                      <p>MÓDULOS OBRIGATÓRIOS:</p>
                      <Accordion
                        expansionPanelProps={{
                          style: {
                            backgroundColor: "transparent"
                          }
                        }}
                        collapses={area.modulos_obrigatorios.map((area_modulo) => {
                            let resultado_modulo = ((this.state.estado_participacao ? this.state.estado_participacao.resultado_modulos : []).find(res => res.id_modulo === area_modulo.id) || {}).resultado;
                            return {
                              title: <React.Fragment>{area_modulo.designacao}<CheckParticipacaoModulos participacao={area_modulo.participacao}/></React.Fragment>,
                              secondaryTitle: <EstadoParticipacaoModulo tooltipPlacement="left" detailed estado={{resultado: resultado_modulo || {}}}/>,
                              content: ({expanded}) => <FormacoesDisponiveisModulo area_modulo={area_modulo} curso={curso} expanded={expanded} classes={classes} ocultar_com_resultado={resultado_modulo?.codigo === "PEND"}/>
                            };
                          }
                        )}
                      />
                      {area.modulos_opcionais.length > 0 && [
                        <p style={{marginTop: 30}}>MÓDULOS OPCIONAIS:</p>,
                        <Accordion
                          expansionPanelProps={{
                            style: {
                              backgroundColor: "transparent"
                            }
                          }}
                          collapses={area.modulos_opcionais.map((area_modulo) => {
                            let resultado_modulo = ((this.state.estado_participacao ? this.state.estado_participacao.resultado_modulos : []).find(res => res.id_modulo === area_modulo.id) || {}).resultado;
                              return {
                                title: <React.Fragment>{area_modulo.designacao}<CheckParticipacaoModulos participacao={area_modulo.participacao}/></React.Fragment>,
                                secondaryTitle: <EstadoParticipacaoModulo tooltipPlacement="left" detailed estado={{resultado: resultado_modulo || {}}}/>,
                                content: ({expanded}) => <FormacoesDisponiveisModulo area_modulo={area_modulo} curso={curso} expanded={expanded} classes={classes} ocultar_com_resultado={resultado_modulo?.codigo === "PEND"}/>
                              };
                            }
                          )}
                        />
                      ]}
                    </div>
                  </React.Fragment>;
                })
                : "A carregar.."}
            </CardBody>
          </Card> : <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Módulos Disponibilizados</h4>
            </CardHeader>
            <CardBody className={classes.courseDetails} style={{paddingLeft: 0, paddingRight: 0}}>
              {this.state.modulos_participante ?
                this.state.modulos_participante.areas.map((area) => {
                  let accordionContent = [];
                  let modulosObrigatorios = "";
                  let modulosObrigatoriosNum = area.modulos_obrigatorios.length;
                  if (modulosObrigatoriosNum > 0)
                    modulosObrigatorios = modulosObrigatoriosNum + (modulosObrigatoriosNum > 1 ? " módulos obrigatórios" : " módulo obrigatório");

                  return <React.Fragment>
                    <div className={classes.modulosAreaHeaderContainer}>
                      <h3 style={{margin: 0, fontSize: "18px"}}>{area.designacao}</h3>
                      <h5 style={{margin: 0, fontSize: 15}}>
                        {modulosObrigatorios}
                        <span className={classes.modulosAreaHeaderTypeLabel}>Área</span>
                      </h5>
                    </div>
                    <div className={classes.modulosParticipanteAccordionWrapper}>
                      <p>Módulos Obrigatórios:</p>
                      <GridContainer>
                        {area.modulos_obrigatorios.map((modulo) => {
                          return <GridItem xs={12} sm={6} lg={4} key={"formacao_" + modulo.id}>
                            <div className={classes.modulosCardContainer}>
                              <p className={classes.modulosCardTitle}>{modulo.designacao}</p>
                            </div>
                          </GridItem>
                        })}
                      </GridContainer>
                      {area.modulos_opcionais.length > 0 && [
                        <p style={{marginTop: 8}}>Módulos Opcionais:</p>,
                        <GridContainer>
                          {area.modulos_opcionais.map((modulo) => {
                            return <GridItem xs={12} sm={6} lg={4} key={"formacao_" + modulo.id}>
                              <div className={classes.modulosCardContainer}>
                                <p className={classes.modulosCardTitle}>{modulo.designacao}</p>
                              </div>
                            </GridItem>
                          })}
                        </GridContainer>
                      ]}
                    </div>
                  </React.Fragment>;
                })
                : "A carregar.."}
            </CardBody>
          </Card>}
        </GridItem>
        <GridItem xs={12} sm={4}>
          <CardUtilizador compact utilizador={curso.diretor} label={"Diretor do curso"} pode_ver_utilizador={curso.diretor.pode_ver_formador}/>
          <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Informações</h4>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <GridContainer>
                {/*<GridItem xs={12} sm={4}>
                  <div className={classes.itemDetalhes}>
                    <h4>{percurso.agrupamento}</h4>
                    <p>Agrupamento</p>
                  </div>
                </GridItem>*/}
                {curso.nucleo && <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{curso.nucleo}</h4>
                    <p>Núcleo</p>
                  </div>
                </GridItem>}
                {curso.regiao && <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{curso.regiao}</h4>
                    <p>Região</p>
                  </div>
                </GridItem>}
                <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{curso.vagas_livres}</h4>
                    <p>Vagas</p>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{curso.preco_inscricao !== null ? (curso.preco_inscricao.toFixed(2).replace(".", ",") + "€") : "Por definir"}</h4>
                    <p>Preço</p>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{curso.modalidade_designacao}</h4>
                    <p>Modalidade</p>
                  </div>
                </GridItem>
                {curso.percurso && <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4><span className="clickable" onClick={() => {
                      window.App.hist.push("/percurso/" + curso.percurso.id);
                    }}>{curso.percurso.designacao}</span></h4>
                    <p>Percurso</p>
                  </div>
                </GridItem>}
                {curso.descricao_longa && <GridItem xs={12} sm={12}>
                  <div className={classes.outrosDetalhes}>
                    <h4>Outras informações</h4>
                    <p>{curso.descricao_longa}</p>
                  </div>
                </GridItem>}
              </GridContainer>
            </CardBody>
          </Card>
          <ConfirmarRegisto acontecimento={curso} designacao={`curso ${curso.descricao}`} dados={{curso: curso.id, preco: curso.preco_inscricao, aceitacao: false}} reloadDetalhes={this.props.reloadDetalhes}/>
          {curso.registo.aprovado && <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Progresso no curso</h4>
            </CardHeader>
            <CardBody>
              {this.state.estado_participacao ? <React.Fragment>
                <EstadoParticipacaoCurso detailed large estado={{resultado: this.state.estado_participacao.resultado}}/>
                {this.state.estado_participacao.resultado.explicacao && <p style={{marginTop: 10}}>{this.state.estado_participacao.resultado.explicacao}</p>}
              </React.Fragment> : <p>O progresso de participação será apresentado aqui</p>}
            </CardBody>
          </Card>}
        </GridItem>
      </GridContainer>
      {["REGISTOS_ABERTOS", "PUBLICO"].includes(curso.estado.codeTxt) && !curso.registo.registado && <Hidden smUp><Card style={{position: "fixed", bottom: 0, margin: 0, zIndex: 10000, left: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}>
        <CardBody>
          <Button style={{margin: "15px 0"}} disabled={curso.estado.codeTxt !== "REGISTOS_ABERTOS"} className={classes.button + " " + classes.info + " " + classes.block} size="md" onClick={this.openRegistrationModal}> Registar ({preco})
          </Button>
          <p style={{textAlign: "center"}}>{texto_registo}</p>
        </CardBody>
      </Card></Hidden>}
    </div>;
  }

  openRegistrationModal = () => {
    const {curso} = this.state;

    let preco = curso.preco_inscricao.toFixed(2).replace(".", ",") + "€";

    //Popup de confirmação de registo
    this.setState({
      modal: <SweetAlert
        warning
        title="Confirmar inscrição"
        onConfirm={async () => {
          await connection.post("curso/participante/inscrever", {
            curso: curso.id,
            preco: curso.preco_inscricao
          });
          general.success("Foi inscrito com sucesso, aguarde o fecho dos registos para saber se foi selecionado", "Sucesso!");
          this.hideModal();
          this.props.reloadDetalhes();
        }}
        onCancel={() => this.hideModal()}
        confirmBtnCssClass={
          this.props.classes.button + " " + this.props.classes.primary
        }
        cancelBtnCssClass={
          this.props.classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Deseja confirmar a sua inscrição no curso {curso.descricao} pelo valor de {preco}?
      </SweetAlert>
    });
  };
}

class FormacoesDisponiveisModulo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formacoes: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    /*if (!props.expanded) {
      return {formacoes: null};
    }*/
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.state.formacoes && this.props.expanded) {
      connection.get("curso/formacao/listagem_disponiveis", {curso: this.props.curso.id, modulo: this.props.area_modulo.id, ocultar_com_resultado: !!this.props.ocultar_com_resultado}, (data) => {
        this.setState({
          formacoes: data
        });
      });
    }
  }

  render() {
    const {area_modulo, curso, classes} = this.props;
    if (this.state.formacoes === null)
      return null;
    return <React.Fragment>
      <SlideDown className={'my-dropdown-slidedown'} style={{padding: "10px 15px", margin: "-10px -15px"}}>
        {this.state.formacoes.length === 0 ?
          <p style={{textAlign: "center"}}>Sem formações disponíveis</p>
          :
          <GridContainer>
            {this.state.formacoes.map((formacao) => {
              return <GridItem xs={12} sm={6} lg={4} key={"formacao_" + formacao.id}>
                <div className={classes.modulosFormacaoContainer}>
                  {(!area_modulo.participacao && formacao.recomendado) ? <span className={classes.modulosFormacaoRibbon}>
                    <span>Recomendado</span>
                  </span> : null}
                  {formacao.estado_participacao.code === 0 && <p className={classes.modulosFormacaoPrice}>{formacao.preco_inscricao ? (formacao.preco_inscricao + "€") : "Gratuito"}</p>}
                  <p className={classes.modulosFormacaoTitle}><StateCircle tooltipPlacement={"top"} state={formacao.estado}/>Formação #{general.pad(formacao.id, 5)}</p>
                  {formacao.estado_participacao.code > 0 ? <p className={classes.modulosFormacaoSubtitle}>{formacao.estado_participacao.designation}</p> : null}
                  <hr style={{margin: "12px 0"}}/>
                  <div>
                    <Tooltip
                      title={<small style={{whiteSpace: "pre"}}><span style={{top: 2, position: "relative"}}><AccessTime fontSize={"inherit"}/></span> {general.guessTimezone().trans}</small>}
                      placement="top"
                      classes={{tooltip: classes.tooltip}}
                    ><>{general.Renderers.dateRenderer(formacao.data_inicio, {hide_timezone: true})}</>
                    </Tooltip>
                  </div>

                  <span>{formacao.local} {formacao.regiao && ((formacao.local ? "(" : "") + formacao.regiao + (formacao.local ? ")" : ""))}</span>
                  <div style={{textAlign: "center", paddingTop: "5px"}}>
                    <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => {
                      window.App.openModal(<SweetAlert
                        showClose
                        style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
                        onConfirm={() => window.App.hideModal()}
                        onCancel={() => window.App.hideModal()}
                        confirmBtnText="Fechar"
                        confirmBtnCssClass={
                          classes.button + " " + classes.primary + " " + classes.buttonConfirm
                        }>
                        <PaginaFormacao id_formacao={formacao.id} visualizacao/>
                      </SweetAlert>);
                    }}>Ver Formação</Button>
                  </div>
                </div>
              </GridItem>
            })}
          </GridContainer>}
      </SlideDown>
    </React.Fragment>
  }
}

export default withStyles(cursosStyle)(VisualizacaoCurso);
